import { Header } from './Header';
import { Footer } from './Footer';
import { ScrollToTop } from './ScrollToTop';

export function SiteLayout({ children }) {
    return (
        <div className="min-h-screen flex flex-col bg-[hsl(var(--background))]">
            <ScrollToTop />
            <Header />
            <main className="flex-1">{children}</main>
            <Footer />
        </div>
    );
}
